import Syslog from './Syslog';

export default Syslog;
